
import { useState, useEffect } from 'react';

export default function StickyLineBar() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="bg-[#0A0A0A]/95 backdrop-blur-md border-t border-white/10 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center justify-between gap-4">
          <div className="hidden sm:block">
            <p className="text-white text-sm font-medium">Atelier Folio for iPad</p>
            <p className="text-white/40 text-xs font-light">2026年3月 Makuake公開予定</p>
          </div>
          <a
            href="https://lin.ee/d6PoCFQ6"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 bg-[#06C755] hover:bg-[#05B34A] text-white text-sm font-medium rounded-xl transition-all cursor-pointer whitespace-nowrap hover:shadow-lg hover:shadow-[#06C755]/20"
          >
            <i className="ri-line-fill text-lg" aria-hidden="true"></i>
            公式LINEで事前登録
          </a>
        </div>
      </div>
    </div>
  );
}
